let announcement_bar = {
    init() {
        const ab_date_container = document.querySelectorAll('.promo-banner__date');

        ab_date_container.forEach(function (item) {
            let ab_enddate = item.querySelector('.promo-banner__end-date').innerText;
            let ab_daysleft = item.querySelector('.promo-banner__days-left');

            if(item.classList.contains('force-midnight')) {
                ab_enddate = new Date();
                ab_enddate.setHours(24,0,0,0);
            };

            // Set the date we're counting down to
            let countDownDate = new Date(ab_enddate);

            // Update the count down every 1 second
            let x = setInterval(function () {

                // Get today's date and time
                let now = announcement_bar.californiaTime();

                // Find the distance between now and the count down date
                let distance = countDownDate.getTime() - now.getTime();
                // Time calculations for days, hours, minutes and seconds
                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.ceil((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the result in the element with id="demo"
                ab_daysleft.innerHTML = days + "d " + hours + "h "
                    + minutes + "m " + seconds + "s ";

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    ab_daysleft.innerHTML = expiredMessage;
                }
            }, 1000);
        });
    },
    californiaTime(date = null) {
        let dt = (date == null) ? new Date() : new Date(date);
        return new Date(dt.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    }
}

document.addEventListener("DOMContentLoaded", function () {
    announcement_bar.init();
});